import React, { useState, useEffect } from "react";
import api from "../services/api";

const roleColors = { citizen: "#1565C0", agent: "#1A5C2A", admin: "#E65100", super_admin: "#6A1B9A" };
const roleLabels = { citizen: "Citoyen", agent: "Agent Municipal", admin: "Administrateur", super_admin: "Super Admin" };

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/auth/users/").then(r => {
      setUsers(Array.isArray(r.data) ? r.data : []);
      setLoading(false);
    }).catch(err => {
      console.error('Users error:', err);
      setLoading(false);
    });
  }, []);

  const filtered = users.filter(u =>
    u.email?.toLowerCase().includes(search.toLowerCase()) ||
    u.full_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Utilisateurs</h1>
        <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>{users.length} utilisateur(s) enregistré(s)</p>
      </div>
      <div style={{ background: "white", borderRadius: 14, padding: "12px 16px", marginBottom: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher par email ou nom..."
          style={{ width: "100%", border: "none", outline: "none", fontSize: 14, fontFamily: "Poppins", color: "#1A1A2E" }} />
      </div>
      {loading ? <p style={{ textAlign: "center", color: "#8A8A9A" }}>Chargement...</p> : (
        <div style={{ display: "grid", gap: 10 }}>
          {filtered.map(u => (
            <div key={u.id} style={{ background: "white", borderRadius: 14, padding: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", display: "flex", alignItems: "center", gap: 14 }}>
              <div style={{ width: 44, height: 44, background: (roleColors[u.role] || "#8A8A9A") + "20", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, color: roleColors[u.role] || "#8A8A9A", fontSize: 16 }}>
                {(u.full_name || u.email || "U")[0].toUpperCase()}
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontWeight: 600, color: "#1A1A2E", fontSize: 14 }}>{u.full_name || "—"}</p>
                <p style={{ margin: "2px 0 0", color: "#8A8A9A", fontSize: 12 }}>{u.email}</p>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <span style={{ background: (roleColors[u.role] || "#8A8A9A") + "20", color: roleColors[u.role] || "#8A8A9A", padding: "4px 10px", borderRadius: 8, fontSize: 11, fontWeight: 700 }}>
                  {roleLabels[u.role] || u.role}
                </span>
                <span style={{ background: u.is_email_verified ? "#1A5C2A20" : "#E6510020", color: u.is_email_verified ? "#1A5C2A" : "#E65100", padding: "4px 10px", borderRadius: 8, fontSize: 11 }}>
                  {u.is_email_verified ? "Vérifié" : "Non vérifié"}
                </span>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <p style={{ textAlign: "center", color: "#8A8A9A", padding: 40 }}>Aucun utilisateur trouvé</p>}
        </div>
      )}
    </div>
  );
}
